/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgenticInsightsConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AiAgenticInsightsConfiguration");
    }

    getFixupPrototypeFunction() { return AiAgenticInsightsConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AiAgenticInsightsConfiguration>): AiAgenticInsightsConfiguration {
        let obj = Object.assign(new AiAgenticInsightsConfiguration(), model);
        AiAgenticInsightsConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgenticInsightsConfiguration>): AiAgenticInsightsConfiguration {
        if (!model) return null;
        return AiAgenticInsightsConfiguration.newInstance(<AiAgenticInsightsConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgenticInsightsConfiguration) {
        if (!obj) return;

        models.AiAgenticInsightsConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgenticInsightsConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiAgenticInsightsConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
